import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://api.olokoo.com'
});

export default axiosInstance;
